import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import ModelDetails from '~/components/ModelDetails';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';
import StructureSetApprovalStatus from './StructureSetApprovalStatus';

type StructureSetDetailsProps = {
    structureSetLabel: string;
    approvalStatus: DICOMApprovalStatus;
    generationModel?: GenerationModelDetails;
};

export default function StructureSetDetails({
    structureSetLabel,
    approvalStatus,
    generationModel,
}: StructureSetDetailsProps) {
    const [validationError, setValidationError] = useState<string | null>(null);

    useEffect(() => {
        if (validationError) {
            enqueueSnackbar(validationError, { variant: 'warning' });
            setValidationError(null);
        }
    }, [validationError]);

    return (
        <Box width="100%" position="relative">
            <Box display="flex" justifyContent="space-between">
                <Typography fontSize={12} noWrap>
                    {structureSetLabel}
                </Typography>
            </Box>
            <ModelDetails generationModel={generationModel} />
            <Box display="flex" justifyContent="space-between" gap={0.5}>
                <Typography variant="body2" fontSize={12}>
                    Review Status
                </Typography>
                <StructureSetApprovalStatus status={approvalStatus} />
            </Box>
        </Box>
    );
}
